<ng-template #rt let-r="result">
  <span [innerHTML]="r.email"></span>
</ng-template>
<div class="become_user_modal_body">
  <div class="become_user_container flex-column-mobile">
    <!-- Display List of Companies and once retrieved, list of users for each office -->
    <!-- Company and office list -->
    <div class="company_list">
      <div class="">
        <i class="ico-search combo-box-icon" aria-hidden="true"></i>
        <input
          type="text"
          appInput
          [(ngModel)]="companySearchString"
          (ngModelChange)="filterCompanies($event)"
          i18n-placeholder
          placeholder="Search by company name..."
        />
      </div>
      <div class="companies">
        @for (company of filteredCompanyList; track company) {
          <div class="company">
            <div
              class="company_title"
              (click)="openOffices(company)"
              tabindex="0"
              role="button"
              (keydown.enter)="openOffices(company)"
            >
              {{ company.name }}
              @if (openOfficeCompany && openOfficeCompany.id === company.id) {
                <i class="ico ico-minus"></i>
              } @else {
                <i class="ico ico-add"></i>
              }
            </div>
            <div class="offices">
              @if (
                company?.offices?.length > 0 &&
                openOfficeCompany &&
                openOfficeCompany.id === company.id
              ) {
                <div class="office_list">
                  @for (office of company.offices; track office) {
                    <div
                      class="office"
                      tabindex="0"
                      (click)="loadUsers(office)"
                      role="button"
                      (keydown.enter)="loadUsers(office)"
                    >
                      {{ office.name }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <!-- List of Users -->
    <div class="user_list">
      @if (isLoading) {
        <div>
          <app-loading-spinner size="sm" />
        </div>
      }

      @if (!isLoading && errorMessage) {
        <div>
          <span>{{ errorMessage }}</span>
        </div>
      }

      @if (!isLoading && (!userList || userList?.length === 0)) {
        <div class="flex">
          <input
            placeholder="Search user by email across all companies..."
            i18n-placeholder
            class="combo-box input-box book-as__input"
            id="typeahead-basic"
            type="text"
            [(ngModel)]="findUserModel"
            (selectItem)="selectUser($event.item)"
            [resultFormatter]="formatter"
            [inputFormatter]="formatter"
            [ngbTypeahead]="findUser"
            [resultTemplate]="rt"
            [disabled]="userList?.length > 0"
          />
          @if (isSearchUserCanBookForLoading | async) {
            <div class="my-bookings-search__loader">
              <app-loading-spinner size="sm" />
            </div>
          }
        </div>
      }
      @if (!isLoading && userList?.length > 0) {
        <div>
          <button
            type="button"
            appButton="small"
            i18n="@@ResetSelectedCompany"
            (click)="resetCompany()"
          >
            Reset selected company
          </button>
          <!-- !doesnt exist yet -->
          @if (limited) {
            <div class="limited">
              <i class="ico-info"></i
              ><span i18n="@@becomeUserModalThisOffice">This office has more than</span>
              {{ total }}
              <span i18n="@@approversModalThisOffice2"
                >users. Please use the column filters to refine your search to be more
                specific</span
              >.
            </div>
          }
          <div class="user-top">
            <div class="user_email">
              <label
                class="header-label become-user-label"
                i18n="@@becomeUserEmail"
                for="become_email"
                >Email</label
              >
              <div class="search_container_no_width">
                <i class="ico-search combo-box-icon" aria-hidden="true"></i>
                <input
                  type="text"
                  appInput
                  id="become_email"
                  [(ngModel)]="userEmailSearchString"
                  (ngModelChange)="filterUsers()"
                  i18n-placeholder
                  placeholder="Search by email..."
                />
              </div>
            </div>
            <div class="user_forename">
              <label
                class="header-label become-user-label"
                i18n="@@becomeUserForename"
                for="become_forename"
                >Forename</label
              >
              <div class="search_container_no_width">
                <i class="ico-search combo-box-icon" aria-hidden="true"></i>
                <input
                  type="text"
                  appInput
                  id="become_forename"
                  [(ngModel)]="userForenameSearchString"
                  (ngModelChange)="filterUsers()"
                  i18n-placeholder
                  placeholder="Search by forename..."
                />
              </div>
            </div>
            <div class="user_surname">
              <label
                class="header-label become-user-label"
                i18n="@@becomeUserSurname"
                for="become_surname"
                >Surname</label
              >
              <div class="search_container_no_width">
                <i class="ico-search combo-box-icon" aria-hidden="true"></i>
                <input
                  type="text"
                  appInput
                  id="become_surname"
                  [(ngModel)]="userSurnameSearchString"
                  (ngModelChange)="filterUsers()"
                  i18n-placeholder
                  placeholder="Search by surname..."
                />
              </div>
            </div>
            <!-- <button class='small-button reset-filter-button'
                              (click)='resetUserFilters()'
                              role="button"
                            i18n="@@becomeUserModalReset"> Reset </button> -->
          </div>
          <div class="users" id="users" tabindex="0">
            @for (user of filteredUserList; track user) {
              <div
                class="user"
                (click)="selectUser(user)"
                role="button"
                (keydown.enter)="selectUser(user)"
                tabindex="0"
              >
                <div class="user_email">{{ user.email }}</div>
                <div class="user_forename">{{ user.forename }}</div>
                <div class="user_surname">{{ user.surname }}</div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" appButton="small" class="small-button--no" i18n="@@becomeUserCancel">
    Cancel
  </button>
  <button type="button" id="button_ok" appButton="small" i18n="@@becomeUserOk">Ok</button>
</div>
